import React, { Component } from 'react';

// dev status: 
// LIVE (production - brightgreen)
// DEV (development - yellowgreen)
// CONCEPT (concept - blue) 
// OFFLINE (offline - lightgrey)

// similar to https://img.shields.io/badge/<SUBJECT>-<STATUS>-<COLOR>.svg
// https://shields.io

const statusMap = {
  "development": {
    style: { backgroundColor: 'burlywood' },
    text: 'DEV',
    title: 'In development'
  },
  "production": {
    style: { backgroundColor: 'yellowgreen' },
    text: 'LIVE',
    title: 'In production'
  },
  "concept": {
    style: { backgroundColor: 'lightsteelblue' },
    text: 'CONCEPT',
    title: 'Concept'
  },
  "offline": {
    style: { backgroundColor: 'darkgray' },
    text: 'OFFLINE',
    title: 'Offline'
  }
}

class DevStatus extends Component {

  constructor(props) {
    super(props);
    this.status = statusMap[props.status];
  }

  render() {
    return (
      <span className="dev-status">
        <span className="shield-text" style={this.status.style} title={this.status.title}>{this.status.text}</span>
      </span>
    );
  }

}

export default DevStatus;





// WEBPACK FOOTER //
// ./src/components/DevStatus.js